// extracted by mini-css-extract-plugin
module.exports = {"Details":"JobDetails_Details__2OjnX","Detail":"JobDetails_Detail__2cN_v"};